import React, { useState } from 'react';

import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../common/general/Button';
import ButtonGroup from '../../../../../common/general/ButtonGroup';

export default function EditFormFields({ itemDefinationData, onSave, modalBox }) {
  const [state, setState] = useState({
    originalFieldName: itemDefinationData?.name || '',
    updatedQuestionFieldName: itemDefinationData?.updatedQuestion || '',
    isRepeatedFields: false
  });

  return (
    <>
      <ModalBoxes.Header>Edit Item</ModalBoxes.Header>
      <ModalBoxes.Body>
        <div className="col-12 form-row p-0 m-0 mt-3">
          <label htmlFor="study"> Original Item Name </label>
          <textarea
            rows="1"
            title={state.originalFieldName}
            value={state.originalFieldName}
            className=" form-control"
            disabled
          />
        </div>
        <div className="col-12 form-row p-0 m-0 mt-3">
          <label htmlFor="study"> New Item Name </label>
          <textarea
            rows="1"
            value={state.updatedQuestionFieldName}
            onChange={event => onChangeName(event)}
            className=" form-control"
          />
        </div>
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority="medium" onClick={modalBox.close}>
            Cancel
          </Button>
          <Button
            onClick={function() {
              onSave(state);
            }}
          >
            Add
          </Button>
        </ButtonGroup>
      </ModalBoxes.Footer>
    </>
  );

  function onChangeName(e) {
    if (e.target.value?.length <= 2000) {
      setState(prevState => ({
        ...prevState,
        updatedQuestionFieldName: e.target.value
      }));
    }
  }
}

EditFormFields.className = 'element-setup-modals';
EditFormFields.size = 'w650';
